/** 未接线屏的占位：说清「哪个接口、哪张卡、为什么不接」。
 *
 * 这是**刻意的空**，不是「待实现」的脚手架：批次 0 的范围就是五个只读入口，
 * 其余 22 屏的接口跟着各自 Should 卡走（`接口跟着卡走，不跟着屏走`）。
 * 页面必须把这句话写出来，否则下一个人会以为这里只是没写完。
 */

import { Card, Lede, PageHead, Note } from "../components/Card";
import { NAV_INDEX, type WireState } from "../lib/nav";
import { reportsForRoute } from "../lib/reports";

const LABEL: Record<WireState, string> = {
  wired: "已接后端",
  "pending-backend": "接口待接",
  "planned-card": "卡未开",
  candidate: "候选能力（未开卡）",
};

export function PlaceholderScreen({ id, title }: { id: string; title: string }): React.ReactNode {
  const item = NAV_INDEX.get(id);
  const wire: WireState = item?.wire ?? "pending-backend";
  const reports = reportsForRoute(`#${id}`);

  return (
    <>
      <PageHead
        title={title}
        sub={
          <>
            路由 <code>#{id}</code> · 状态 {LABEL[wire]}
          </>
        }
      />
      <Lede>
        这一屏在原型里已经画好了，但**批次 0 不接它**。原因写在下面；接口跟着 Should 卡走，不跟着屏走，
        所以这里没有任何数字——填上原型数据就等于假装已经接通。
      </Lede>
      <div className="grid g2">
        <Card title="为什么没有数据">
          <Note tone={wire === "planned-card" ? "warn" : ""}>
            {item?.why ?? "该屏尚未排期。"}
          </Note>
          <div style={{ marginTop: 10 }}>
            <dl className="kv">
              <dt>路由</dt>
              <dd>#{id}</dd>
              <dt>状态</dt>
              <dd>{LABEL[wire]}</dd>
              <dt>原型参照</dt>
              <dd>docs/design/ui-prototype/views/{id}.js</dd>
            </dl>
          </div>
        </Card>
        <Card title="相关的报告占位" sub="报告是一等路由（condor 形状）">
          {reports.length === 0 ? (
            <div className="empty">这一屏没有登记报告占位</div>
          ) : (
            <dl className="kv">
              {reports.map((report) => (
                <div key={report.id} style={{ display: "contents" }}>
                  <dt>{report.title}</dt>
                  <dd>
                    {report.source} · 依赖 {report.requires}
                  </dd>
                </div>
              ))}
            </dl>
          )}
        </Card>
      </div>
    </>
  );
}
